module.exports = __webpack_public_path__ + "static/media/approve.2b0f3441.svg";